/* eslint-disable no-console */

import { JL } from 'jsnlog';
import { isTraceLoggingEnabled } from './index';
import Constants from './Constants';
import { getSessionAccessToken } from './browserStorage';

export const beforeSend = (xhr) => {
    const token = getSessionAccessToken();
    xhr.setRequestHeader('Authorization', token ? `${Constants.BEARER_PREFIX} ${token}` : '');
};

const consoleAppender = JL.createConsoleAppender('consoleAppender');
const ajaxAppender = JL.createAjaxAppender('ajaxAppender');
ajaxAppender.setOptions({
    url: `${Constants.IS_HTTPS ? 'https' : 'http'}://${process.env.REACT_APP_SERVER_HOST || window.location.host}${Constants.CLIENT_LOGGER_PATH}`,
    beforeSend,
});
const appenders = [
    consoleAppender,
    ajaxAppender,
];

const generalLogLevel = isTraceLoggingEnabled()
    ? JL.getTraceLevel()
    : JL.getWarnLevel();

const createJSNLogger = (name) => {
    if (typeof name !== 'string' || !name || name.trim().length === 0) {
        throw new Error('Provide descriptive logger name!');
    }
    return JL(name).setOptions({
        appenders,
        level: generalLogLevel,
    });
};

const loggers = [];
export const createLogger = (name) => {
    if (!loggers[name]) {
        loggers[name] = createJSNLogger(name);
    }
    const logWrapper = (messageLogLevel, fallbackLog) => (...logParams) => {
        const token = getSessionAccessToken();
        if (token) {
            loggers[name].log(messageLogLevel, ...logParams);
        } else if (messageLogLevel >= generalLogLevel) {
            fallbackLog(`${name}:`, ...logParams);
        }
    };
    return {
        trace: logWrapper(JL.getTraceLevel(), console.trace),
        debug: logWrapper(JL.getDebugLevel(), console.debug),
        info: logWrapper(JL.getInfoLevel(), console.info),
        warn: logWrapper(JL.getWarnLevel(), console.warn),
        error: logWrapper(JL.getErrorLevel(), console.error),
        fatal: logWrapper(JL.getFatalLevel(), console.error),
        fatalException: logWrapper(JL.getFatalLevel(), console.error),
    };
};

export const enableLoggers = () => JL.setOptions({ enabled: true });

export const disableLoggers = () => JL.setOptions({ enabled: false });
